'use client';

import config from '@/config';
import Image from 'next/image';

export default function SectionPlayAnywhere() {
  return (
    <section className="relative bg-paper-100 paper-grain flex flex-col items-center py-20 lg:py-28 px-6 lg:px-8 overflow-hidden">
      <div className="text-center max-w-2xl mx-auto mb-12">
        <p className="font-hand text-brand-600 text-2xl mb-3 -rotate-2 inline-block">
          play wherever you like
        </p>
        <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] text-ink-900 leading-[1.02] mb-5">
          Lecture hall, library,
          <br />
          <span className="italic font-normal">campus coffee shop.</span>
        </h2>
        <p className="font-display text-ink-600 leading-relaxed lg:text-lg max-w-xl mx-auto">
          Players get their own view of the map. Host from anywhere, and
          students can join from anywhere.
        </p>
      </div>

      <div className="relative">
        {/* Hand-drawn dotted route around the phone */}
        <svg
          aria-hidden="true"
          className="hidden lg:block absolute -inset-32 w-[calc(100%+16rem)] h-[calc(100%+16rem)] text-brand-500/60 pointer-events-none"
          viewBox="0 0 600 900"
          fill="none"
        >
          <path
            d="M60 120 C 140 60, 260 40, 360 90 S 540 220, 530 380 S 420 720, 280 800 S 80 760, 60 580"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray="2 14"
            fill="none"
          />
          <circle cx="60" cy="120" r="6" fill="currentColor" />
          <circle cx="60" cy="580" r="6" fill="currentColor" />
        </svg>

        <div className="w-[214px] h-[445px] rounded-[34px] lg:w-[390px] lg:h-[812px] xl:w-[406px] xl:h-[845px] relative overflow-hidden lg:rounded-[71px] shadow-2xl shadow-ink-900/15">
          <Image
            src={`${config.imagesBaseUrl}/landing/phone frame.png`}
            fill
            alt="Phone"
            className="z-10"
          />
          <video
            width="100%"
            autoPlay
            muted
            loop
            playsInline
            className="w-[calc(100%-18px)] relative left-[9px] top-[1px] h-full object-cover"
          >
            <source
              src={`${config.imagesBaseUrl}/landing/Player demo 390x823.mp4`}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </section>
  );
}
